import { useEffect, useState } from "react";

// Match the existing mobile shell boundary; desktop keeps its own composition.
export function useMobileLayout() {
  const [mobile, setMobile] = useState(() => window.matchMedia("(max-width:700px)").matches);
  useEffect(() => {
    const media = window.matchMedia("(max-width:700px)");
    const changed = () => setMobile(media.matches);
    media.addEventListener("change", changed);
    return () => media.removeEventListener("change", changed);
  }, []);
  return mobile;
}
